export enum SupportedChains {
    MAINNET = 1,
    ARBITRUM_ONE = 42161,
    // ROPSTEN = 3,
    // RINKEBY = 4,
    // GOERLI = 5,
    // KOVAN = 42,
}

export const CHAIN_IDS_TO_NAMES: {
    [x: number]: string;
} = {
    [SupportedChains.MAINNET]: 'Ethereum',
    [SupportedChains.ARBITRUM_ONE]: 'Arbitrum',
};

export const SUPPORTED_CHAIN_IDS = [
    SupportedChains.MAINNET,
    SupportedChains.ARBITRUM_ONE,
    // networks.ROPSTEN,
    // SupportedChains.RINKEBY,
    // networks.GOERLI,
    // networks.KOVAN,
];

export enum SupportedConnectors {
    METAMASK = 'Metamask',
    WALLET_CONNECT = 'WalletConnect',
    COINBASE = 'Coinbase Wallet',
    TREZOR = 'Trezor',
    PORTIS = 'Portis',
    LEDGER = 'Ledger',
    TORUS = 'Torus',
    FORTMATIC = 'Formatic',
    UAUTH = 'Login with UD',
    BITKEEP = 'Bitkeep',
    NABOX = 'Nabox',
    FOX = 'FoxWallet',
    OKX = 'OKX',
}

export enum Theme {
    LIGHT = 'light',
    DARK = 'dark',
}

export enum Socials {
    DISCORD = 'DISCORD',
    TWITTER = 'TWITTER',
    TELEGRAM = 'TELEGRAM',
    MEDIUM = 'MEDIUM',
    GITBOOK = 'GITBOOK',
    LINKEDIN = 'LINKEDIN',
}

export enum SupportedAssets {
    USDC = '$USDC',
    DAI = '$DAI',
    USDT = '$USDT',
    FALLBACK = 'FALLBACK',
}

export enum SortDirection {
    ASC = 'SORT_ASCENDING',
    DESC = 'SORT_DESCENDING',
}

export enum WithdrawlTypes {
    SLOW = 'Slow',
    FAST = 'Fast',
}

export enum IncentivizeSpoolTypes {
    EXTEND = 'EXTEND',
    INCREASE = 'INCREASE',
    REINCENTIVIZE = 'REINCENTIVIZE',
}

export enum StrategyStrength {
    WEAK = 'weak',
    MEDIUM = 'medium',
    STRONG = 'strong',
}

export enum TimeConversions {
    SECONDS_PER_MINUTE = 60,
    SECONDS_PER_HOUR = 3600,
    SECONDS_PER_DAY = 86400,
    SECONDS_PER_YEAR = 31556926,
    MINUTES_PER_DAY = 1440,
    HOURS_PER_DAY = 24,
}

export const ALL_RISK_MODELS = 'All Risk Models';
export const ALL_ASSETS = 'All Assets';

// STATUS
export const APPROVAL_PENDING = 'Please wait as your Approval is being Confirmed.';

export const WITHDRAWAL_SLOW = `Please wait... Once your transaction is confirmed, your withdrawal for the Spool will be marked as "<strong>Pending</strong>" and will be "<strong>Ready to Claim</strong>" on the next Spool rebalance.`;
export const WITHDRAWAL_FAST = `Please wait... Once your transaction is confirmed, your Fast Withdrawal for the Spool will be complete. Final values may vary due to variations in slippage.`;
export const CLAIM_WITHDRAWAL = `Please wait...Your withdrawal will be complete once your transaction is confirmed.`;
export const WITHDRAWAL_COMPLETED = 'Your Withdrawal has been Completed!';

export const DEPOSIT_PENDING = `Please wait… Once your transaction is confirmed, your deposit for the Spool will be marked as "<strong>Pending</strong>" and will be deposited in the Spool on the next Spool Rebalance.`;

export const CLAIM_REWARDS_PENDING = 'Please wait as your Rewards are being Claimed';
export const CLAIM_PERFORMANCE_FEES_PENDING =
    'Please wait as your Performance Fees are being Claimed';
export const REWARDS_CLAIMED = 'Your rewards have been Claimed!';
export const PERFORMANCE_FEES_CLAIMED = 'Your performance fees have been Claimed!';

// STAKING
export const STAKE_PENDING = 'Please wait while your $SPOOL is Staked.';
export const STAKE_CONFIRMED = 'Your SPOOL has been Staked. <br />Welcome to the DAO';

export const UNSTAKE_PENDING = 'Please wait while your $SPOOL is Unstaked.';
export const UNSTAKE_CONFIRMED = 'Your SPOOL has been Unstaked.';

export const CREATE_SPOOL_PENDING = 'Please wait as your Spool is being Created.';
export const SPOOL_CREATED = 'Your Spool has been Created.';

export const EMISSION_STAKE_PENDING =
    'Please wait... Once your transaction is confirmed, your emission rewards will be claimed and then staked.';
export const EMISSION_STAKE_CONFIRMED = 'Your Emission Rewards have been Staked!';

// INCENTIVIZE SPOOL
export const INCENTIVIZE_SPOOL_PENDING =
    'Please wait while your Spool is being incentivized. ';
export const SPOOL_INCENTIVIZED = 'Your Spool is now incentivized!';

export const EXTEND_INCENTIVES_PENDING =
    'Please wait... Once your transaction is confirmed, your Spool’s Incentivized Rewards will be extended.';
export const INCENTIVES_EXTENDED = 'Your Spool’s Incentives have been Extended!';

export const INCREASE_INCENTIVES_PENDING =
    'Please wait... Once your transaction is confirmed, your Spool’s Incentivized Rewards will be increased.';
export const INCENTIVES_INCREASED = 'Your Spool’s Incentives have been Increased!';

export const REINCENTIVIZING_PENDING =
    'Please wait... Once your transaction is confirmed, your Spool will be Re-Incentivized.';
export const INCENTIVES_REINCENTIVIZED = 'Your Spool has been Re-Incentivized!';

export const INCENTIVES_REMOVE_PENDING =
    'Please wait... Once your transaction is confirmed, your Spool’s Incentive Token will be removed.';
export const INCENTIVES_REMOVED = 'Your Spool’s Incentive Token has been Removed!';

// CREATOR FEES
export const CLAIM_CREATOR_FEES_PENDING =
    'Please wait as your creator fees are being Claimed';
export const CREATOR_FEES_CLAIMED = 'Your creator fees have been Claimed!';

// DAO Vesting
export const VESTED_SPOOL_PENDING =
    'Please wait as your Vested $SPOOL tokens are Claimed.';
export const VESTED_SPOOL_CLAIMED =
    'Your available Vested $SPOOL tokens have been Claimed';

// EMISSIONS
export const VOTE_PENDING = `Please wait as your Vote is being Confirmed`;
export const VOTE_CONFIRMED = 'Your Vote has been Confirmed';
export const VOTE_PENDING_GNOSIS = 'Your Vote is pending confirmation';

// ERROR
export const INSUFFICIENT_FUNDS_ERROR = 'Insufficient Funds';
export const WITHDRAWAL_AMOUNT_OVERFLOW = 'Withdrawal amount exceeds balance';
export const LOWER_INCENTIVE_RATE_ERROR =
    'New incentive rate is lower than previous rate';
export const INCENTIVE_TOKEN_EQUALS_UNDERLYING_ASSET =
    'Incentive Token cannot be the same as the underlying Spool asset';
